import React from 'react';
import SearchInput from '../searchinput';
import Logo from '../logo';
import MajorCategories from '../majorcategories';
import LogoutBtn from '../toplinks/btnlogout';

export default class HeaderSearchBar extends React.Component {
  static propTypes = {
    logo: React.PropTypes.object,
    loggedUser: React.PropTypes.object
  };

  renderLogoutLink = () => {
    if (this.props.loggedUser) {
      return <LogoutBtn {...this.props} />;
    }
  };

  render () {
    return (
      <div className="header__main">
        <div className="header__main__inner">
          <Logo {...this.props.logo} />
          <MajorCategories key="majorcategories" hasMore panel="bot" {...this.props} />
          <SearchInput {...this.props} closeOtherPanels />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/searchbar/index.js